import store from '@/store'

export default function axiosErrorHandler (error) {
  return new Promise((resolve, reject) => {
    console.log('Processing error:')
    if (error.response) {
      console.log(error.response.data)
      console.log(error.response.status)
      console.log(error.response.headers)
      if (error.response.status === 401) {
        store.dispatch('auth/logout')
      }
      reject(error.response.data.error)
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error', error.message)
      reject(error.message)
    }
  })
}
